import {
  CustomFieldFragment,
  CustomFieldValueFragment,
  CustomFieldGridFragment,
} from "__generated__/graphql";

export interface ICustomFieldNameValuePair {
  name: string;
  value: CustomFieldValueFragment | null;
}

export const getCustomFieldNameValuePairs = (
  customFields: CustomFieldFragment[] | CustomFieldGridFragment[],
): ICustomFieldNameValuePair[] => {
  return customFields.map((customField) => {
    const { name, value } = customField;

    return { name, value };
  });
};

export const getCustomFieldValueByType = (
  value: CustomFieldValueFragment | null,
) => {
  if (value) {
    switch (value.__typename) {
      case "CustomFieldRichText":
        return value.richContent.trixHtml;
      case "CustomFieldEmployee":
        return value.employee;
      case "CustomFieldDate":
        return value.dateValue;
      case "CustomFieldString":
        return value.stringValue;
      case "CustomFieldNumber":
        return value.numberValue;
      case "CustomFieldOptional":
        return value.option;
      case "CustomFieldMulti":
        return value.multiOption;
      case "CustomFieldCompany":
        return value.companies;
      case "CustomFieldContact":
        return value.contacts;
      case "CustomFieldMoney":
        return value.moneyValue;
      case "CustomFieldMultiCountry":
        return value.countries;
      case "CustomFieldMultiEmployee":
        return value.employees;
      case "CustomFieldFullDateTime":
        return value.dateTime;
    }
  }
  return null;
};
